export interface GenerateChunksProps {
  start_time?: number;
  end_time?: number;
  chunk_time?: number;
  progressive_loading?: boolean;
}

export const generateChunks = ({
  start_time,
  end_time,
  chunk_time = 1000 * 60 * 60 * 24 * 5,
  progressive_loading = false
}: GenerateChunksProps): { start_time: number; end_time: number }[] => {
  const duration = (end_time || 0) - (start_time || 0)
  if (start_time === undefined || end_time === undefined || duration <= 0) return []
  if (!progressive_loading && (!chunk_time || chunk_time <= 0)) return []
  const day = 1000 * 60 * 60 * 24
  const chunk_list: { start_time: number; end_time: number }[] = []
  let offset = 0
  while (offset < duration) {
    const size = progressive_loading ? Math.min(chunk_list.length + 1, 5) * day : chunk_time
    chunk_list.push({
      start_time: end_time - Math.min(offset + size, duration),
      end_time: end_time - offset
    })
    offset += size
  }
  return chunk_list.reverse()
}
